module.exports = __webpack_public_path__ + "static/media/lifepackXkemenkes.32d187ed.png";